import axios from '@/libs/api.request'
//行政地区列表
export const apiDeliverysettingArea = data => {
    return axios.request({
        url: '/deliverysetting/area',
        method: 'post',
        data
    })
}
//重庆地区列表
export const apiChongQingArea = data => {
    return axios.request({
        url: '/deliverysetting/cq-area',
        method: 'post',
        data
    })
}
//运费设置详情
export const apiDeliverysettingConfig = data => {
    return axios.request({
        url: '/deliverysetting/config',
        method: 'post',
        data
    })
}
//删除
export const apiDeliverysettingDelete = data => {
    return axios.request({
        url: '/deliverysetting/delete',
        method: 'post',
        data
    })
}
//保存
export const apiDeliverysettingSave = data => {
    return axios.request({
        url: '/deliverysetting/save',
        method: 'post',
        data
    })
}
